import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { ButtonComp } from 'atoms/Buttons';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { DAYS, SHARED_CONSTANTS } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { formatDateTime, getUnixTimeInSeconds } from 'common/utilities/dayJsUtils';
import { isPickupOrCateringDisposition } from 'common/utilities/utils';
import {
  geActiveOrderHistoryAdditionalInfoLabel,
  getActiveOrderHistoryButtonLabel,
  getActiveOrderHistoryInfo,
  getActiveOrderHistoryTitle,
  onTrackOrderBtnClickHandler,
} from 'components/activeOrders/utils/activeOrdersUtils';

export const getActiveOrderHistoryHeading = params => {
  const { postActiveOrderHistoryDetailsList } = params?.activeTrackerDetails;

  return (
    postActiveOrderHistoryDetailsList?.length > 0 && (
      <div className='active-orders-title col-12'>
        <img src={IMAGE_PATH?.Strips} alt='Red Strip' class='account-icon' />
        <h4 class='currentStatus'>
          {`${translateWithI18Next(TRANSLATE_MAPPING_KEY?.CURRENT_ORDERS)} (${
            postActiveOrderHistoryDetailsList?.length
          })`}
        </h4>
      </div>
    )
  );
};

export const getActiveOrderHistoryTitleJSX = params => {
  return (
    <div className='active-orders-details-info col-12'>
      <span>{getActiveOrderHistoryTitle(params)}</span>
    </div>
  );
};

const getActiveOrderHistoryInfoDetailsJSX = params => {
  const { postActiveOrderDetail } = params;
  if (translateWithI18Next(isPickupOrCateringDisposition(postActiveOrderDetail?.service))) {
    const timeStamp = getUnixTimeInSeconds(postActiveOrderDetail?.fulfillmentDateTime);
    return (
      <span className='col-12'>
        <span>
          {translateWithI18Next(DAYS[new Date(timeStamp).getDay()])}{' '}
          {formatDateTime(timeStamp, SHARED_CONSTANTS?.DD_MM_YY_WITH_SLASH)}
        </span>
        <br />
        <span> {postActiveOrderDetail?.store?.name}</span>
      </span>
    );
  } else {
    return <span className='col-12'>{getActiveOrderHistoryInfo(params)}</span>;
  }
};

export const getActiveOrderHistoryInfoJSX = params => {
  return (
    <div className='active-orders-details-panel-info col-12 col-lg-8'>
      {getActiveOrderHistoryInfoDetailsJSX(params)}
    </div>
  );
};

export const getActiveOrderHistoryButtonJSX = params => {
  return (
    <ButtonComp
      data-testid='active-track-order-button'
      className='button col-12'
      aria-label={getActiveOrderHistoryButtonLabel(params)}
      onClickHandler={() => onTrackOrderBtnClickHandler(params)}
      id='activeTrackOrderItemButton'
      type='submit'
    >
      <span>{getActiveOrderHistoryButtonLabel(params)}</span>
    </ButtonComp>
  );
};

export const geActiveOrderHistoryAdditionalInfoLabelJSX = params => {
  const { enableReadytoCollectLabel } = params;
  return enableReadytoCollectLabel && <span>{geActiveOrderHistoryAdditionalInfoLabel(params)}</span>;
};

export const getActiveOrderHistoryContainerJSX = params => {
  const { postActiveOrderHistoryDetailsList, enableGlobalOrderTracking, enableReadytoCollectLabel } =
    params?.activeTrackerDetails;

  return (
    postActiveOrderHistoryDetailsList &&
    postActiveOrderHistoryDetailsList.map(postActiveOrderDetail => (
      <div className='active-orders-panel col-12 col-lg-7'>
        <div class='circle-top-left'></div>
        <div className='active-orders-details'>
          {getActiveOrderHistoryTitleJSX({
            postActiveOrderDetail: { ...postActiveOrderDetail, enableGlobalOrderTracking },
          })}
          <div className='active-orders-details-panel col-12'>
            {getActiveOrderHistoryInfoJSX({ postActiveOrderDetail })}
            <div className='active-track-order-btn col-12 col-lg-4'>
              {getActiveOrderHistoryButtonJSX({ postActiveOrderDetail, ...params })}
            </div>
          </div>
          <div className='active-orders-details-add-info col-12'>
            {geActiveOrderHistoryAdditionalInfoLabelJSX({ postActiveOrderDetail, enableReadytoCollectLabel })}
          </div>
        </div>
        <div class='circle-bottom-right'></div>
      </div>
    ))
  );
};
